// extracted by mini-css-extract-plugin
module.exports = {"inviteCallout":"invite-callout_inviteCallout_1ok","inviteCalloutSvgs":"invite-callout_inviteCalloutSvgs_3BX"};